import { useQueryData } from "@src/hooks/useQueryData";
import type { WsDepotCardExtends } from "../../../../../api/wsDepotCards";
import { wsInvActsServices, type WsInvActContentExtends } from "../../../../../api/wsInvActs";

/** Связи строки состава АИ для формы детали. */
export const WS_INV_ACT_CONTENT_DETAIL_INCLUDES = {
    include: ["WsDepotCard"] satisfies Array<keyof WsInvActContentExtends>,
    includeWsDepotCard: ["Stockobj", "ProductionType", "Measure"] satisfies Array<keyof WsDepotCardExtends>,
} as const;

/** Server-state detail элемента состава АИ. */
export function useWsInvActContentDetailQuery(contentCode: number) {
    return useQueryData({
        queryKey: ["workshop", "wsInvAct", "content", contentCode],
        queryFn: async () => {
            const content = await wsInvActsServices.content.loadOne({
                flt: { Codes: [contentCode] },
                ...WS_INV_ACT_CONTENT_DETAIL_INCLUDES,
            });

            if (content == null) {
                throw new Error("Не найден элемент состава АИ");
            }

            return content;
        },
        enabled: contentCode > 0,
        meta: { errorSource: "workshop.wsInvAct.content.detail" },
    });
}
